const API_BASE = import.meta.env.VITE_API_URL || '/api';

async function get<T>(path: string): Promise<T> {
  const resp = await fetch(`${API_BASE}${path}`)
  if (!resp.ok) {
    const text = await resp.text()
    throw new Error(`API ${resp.status}: ${text}`)
  }
  return resp.json() as Promise<T>
}

export interface LegInfo {
  strike: number
  type: string
  action: 'BUY' | 'SELL'
  mark: number
  bid: number
  ask: number
  entry_price: number
}

export interface Strategy {
  ev: number
  ev_after_fee: number
  ev_pct: number
  total_fees: number
  max_loss: number
  max_profit?: number
  ev_per_dollar: number
  strategy_type: string
  underlying?: string
  symbol?: string
  strike?: number
  expiry?: string
  dte?: number
  mark?: number
  probability?: number
  moneyness?: string
  bid?: number
  ask?: number
  volume?: number
  oi?: number
  net_debit?: number
  net_credit?: number
  is_credit?: boolean
  breakeven?: number
  risk_reward?: number
  legs?: LegInfo[]
}

export interface ScanResponse {
  strategies: Strategy[]
  count: number
  underlying: string
  source: string
  spot_price: number
}

export interface ChainItem {
  symbol: string
  strike: string
  type: string
  expiryDate: string
  dte?: number
  bid: string
  ask: string
  markPrice: string
  lastPrice: string
  volume: string
  openInterest: string
  iv?: string
}

export interface ChainResponse {
  chain: ChainItem[]
  count: number
  spot_price: number
}

export interface HealthResponse {
  status: string
  spot_price?: number
}

export const api = {
  health: () => get<HealthResponse>('/health'),
  scan: (params?: Record<string, string>) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : ''
    return get<ScanResponse>(`/scan${qs}`)
  },
  chain: (params?: Record<string, string>) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : ''
    return get<ChainResponse>(`/chain${qs}`)
  },
}
